const _ = require('lodash');

const defaultState = {
    inboxInstructions: [],
    ruleAlarm: '',
    indispsAlarms: [],
    units: [],
    configValuesHC: [],
    ctchActiveAlarms: 'all',
    EDInstructions: []
}
  
export default (state=defaultState, action={}) => {
    switch (action.type) {

        case 'FETCH_INSTRUCTIONS_FOOTER_FULFILLED': {
    
            return {
            ...state,
            inboxInstructions: action.payload.data
            }
        }

        case 'FETCH_INDISPS_ALARMS_FULFILLED': {
    
            return {
            ...state,
            indispsAlarms: action.payload.data
            }
        }      

        case 'FETCH_RULE_PRODUCTION_ALARM_FULFILLED': {
            
            return {
            ...state,
            ruleAlarm: action.payload.data[0].RULE_VALUE
            }
        }

        case 'FETCH_RULE_ESP_CONFIG_VALUES_FULFILLED': {
            let auxRule;
            let newItem = {};
            for(var i = 0; i < action.payload.data.length; i++){
                auxRule = action.payload.data[i];
                newItem[auxRule['RULE_CODE']] = auxRule['RULE_VALUE'];
            }

            return {
                ...state,
                configValuesHC: newItem,
            }
        }      
                
        case 'ADD_INSTRUCTIONS_FOOTER_FULFILLED': {
            
            let mergedInstructions = [...state.inboxInstructions, ...action.newInstructions];
            let orderedInstructions = _.orderBy(mergedInstructions, ['ID','CHANGE_DATETIME','BEGIN_DATE','BEGIN_TIME','ORDER_PHO'], ['desc','desc', 'asc', 'asc', 'asc']);

            return {
                ...state,
                inboxInstructions: orderedInstructions
            }         
        }

        case 'VALIDATE_INSTRUCTION_FOOTER_FULFILLED': {
            const id = action.instructionId;

            return {
                ...state,
                inboxInstructions: state.inboxInstructions.filter(item => item.ID !== id)
            }
        }

        case 'SEE_INSTRUCTION_FOOTER_FULFILLED': {
            const id = action.instructionId;
            let status = 'ACEITE';

            return {
                ...state,
                inboxInstructions: state.inboxInstructions.map(item => item.ID === id ?  {...item, STATUS: status} : item)
            }
        }

        case 'REJECT_INSTRUCTION_FOOTER_FULFILLED': {
            const id = action.instructionId;
            let status = 'RECLAMADA';

            return {
                ...state,
                inboxInstructions: state.inboxInstructions.map(item => item.ID === id ?  {...item, STATUS: status} : item)
            }
        }
        
        case 'CANCEL_INSTRUCTION_FOOTER_FULFILLED': {
            const id = action.instructionId;
            return {
                ...state,
                inboxInstructions: state.inboxInstructions.filter(item => item.ID !== id),
                EDInstructions: state.EDInstructions.filter(item => item.ID !== id)
            }
        }

        case 'BAN_INSTRUCTION_FOOTER_FULFILLED': {
            const id = action.instructionId;
            const comments = action.comments;
            const status = 'ACEITE';
            return {
                ...state,
                inboxInstructions: state.inboxInstructions.map(item => item.ID === id ? {...item, STATUS: status , COMMENTS_EDPP: comments} : item)
            }
        }

        case 'EDIT_INSTRUCTION_FOOTER_FULFILLED': {
            const id = action.instruction.ID;
            const newItem = action.instruction;
            let finalList = [];

            // Step 1. Remove previous previous version of ID
            // Step 2. Add new version
            state.inboxInstructions.forEach(element => {

            if (element.ID === id ) {
                finalList.push(newItem);
            }
            else {
                finalList.push(element);
            }
            
            });

            return {
            ...state,
            inboxInstructions: finalList
            }        
        }

        case 'SETUPALARM_INSTRUCTION_FOOTER_FULFILLED': {
            const id = action.instruction.ID;
            const newItem = action.instruction;
            let finalList = [];

            // Step 1. Remove previous previous version of ID
            // Step 2. Add new version
            state.inboxInstructions.forEach(element => {

            if (element.ID === id ) {
                finalList.push(newItem);
            }
            else {
                finalList.push(element);
            }
            
            });

            return {
            ...state,
            inboxInstructions: finalList
            }        
        }

        //units
        case 'FETCH_ALL_UNITS_FULFILLED': {
            
            let arrayMain=[];
            let newItem = {};
            
            if(Array.isArray(action.payload.data)){
                action.payload.data.forEach((element,index) => {
                    newItem={};//limpa para criar um novo
                    newItem["key"] = index;
                    newItem["text"] = element.COD_UF;
                    newItem["value"] = element.COD_SIME;
                    newItem["numbergroups"] = element.NUM_GROUPS;
                    newItem["maxpow"] = element.MAX_POW;
                    newItem["mintec"] = element.MIN_TEC;
                    newItem["maxpowb"] = element.MAX_POW_B;
                    newItem["mintecb"] = element.MIN_TEC_B;
                    newItem["flag_g"] = element.FLAG_G;
                    newItem["flag_gt"] = element.FLAG_GT;
                    newItem["flag_b"] = element.FLAG_B;
                    newItem["flag_bt"] = element.FLAG_BT;
                    newItem["flag_gc"] = element.FLAG_C;
                    newItem["flag_bc"] = element.FLAG_CB;
                    newItem["cp_desc"] = element.CP_DESC;
                    newItem["tech"] = element.TECHNOLOGY;
                    newItem["flag_mini"] = element.FLAG_MINI;
                    newItem["country_code"] = element.COUNTRY_CODE;
                    newItem["flag_active"] = element.FLAG_ACTIVE;
                    newItem["mkt_participant"] = element.MKT_PARTICIPANT;
                    arrayMain.push(newItem);
                });
            }else{
                console.log('FETCH_ALL_UNITS_FULFILLED error: ');
                console.dir(action.payload.data);
            }

            return {
            ...state,
            units: arrayMain
            }
        }

        case 'SETUPCTCH_ACTIVE_ALARMS_FULFILLED': {
            return {
            ...state,
                ctchActiveAlarms: action.alarmValue
            }        
        }

        case 'FETCH_ED_INSTRUCTIONS_FOOTER_FULFILLED': {
            return {
                ...state,
                EDInstructions: action.payload.data,
            }
        }

        default:
            return state;
        }
}



// WEBPACK FOOTER //
// ./src/reducers/footer-reducer.js